import React from 'react';
import { Box, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

interface DrawerHeaderProps {
  onClose: () => void;
}

export const DrawerHeader: React.FC<DrawerHeaderProps> = ({ onClose }) => (
  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
    <IconButton onClick={onClose}>
      <CloseIcon />
    </IconButton>
  </Box>
);














